(() => {
  'use strict';
  const root=window.Shopify?.routes?.root||'/';
  const config=document.querySelector('[data-unified-ui]');if(!config)return;
  const ui=JSON.parse(config.textContent);
  const language=(document.documentElement.lang||'it').slice(0,2);
  const messages={it:{added:'Aggiunto al carrello.',addedMany:'Prodotti aggiunti al carrello.',continue:'Continua a scegliere',cart:'Vai al carrello',label:'Carrello'},en:{added:'Added to cart.',addedMany:'Products added to cart.',continue:'Continue shopping',cart:'View cart',label:'Cart'},fr:{added:'Ajouté au panier.',addedMany:'Produits ajoutés au panier.',continue:'Continuer mes achats',cart:'Voir le panier',label:'Panier'}};
  const text=messages[language]||messages.it;
  function renderCount(count){
    if(!Number.isInteger(count)||count<0)return;
    document.querySelectorAll('.ma-cart-label').forEach(label=>{
      label.textContent=text.label+(count?' ('+count+')':'');
      label.closest('a')?.setAttribute('aria-label',text.label+' ('+count+')');
    });
    document.querySelectorAll('#cart-icon-bubble').forEach(icon=>{
      let bubble=icon.querySelector('.cart-count-bubble');
      if(!count){bubble?.remove();return;}
      if(!bubble){bubble=document.createElement('div');bubble.className='cart-count-bubble';icon.append(bubble);}
      const number=document.createElement('span');number.setAttribute('aria-hidden','true');number.textContent=count;
      const accessible=document.createElement('span');accessible.className='visually-hidden';accessible.textContent=text.label+' ('+count+')';
      bubble.replaceChildren(number,accessible);
    });
  }
  async function refresh(fallback){
    try{const cart=await request('cart.js',{cache:'no-store'});renderCount(cart.item_count);}
    catch{renderCount(fallback);}
  }
  function confirm(container,options={}){
    if(!container)return;
    const styleAction=(action,primary=false)=>{action.className='ma-button';action.setAttribute('style','display:inline-flex;align-items:center;justify-content:center;flex:1 1 150px;min-height:46px;box-sizing:border-box;padding:12px 16px;border:1px solid var(--ma-ink,#292824);text-transform:uppercase;letter-spacing:.06em;font-family:inherit;font-size:12px;font-weight:600;line-height:1.4;text-decoration:none;cursor:pointer;background:'+(primary?'var(--ma-ink,#292824);color:#fff;':'transparent;color:var(--ma-ink,#292824);'));};
    const message=document.createElement('span');message.textContent=options.multiple?text.addedMany:text.added;
    const cartLink=document.createElement('a');cartLink.href=root+'cart';styleAction(cartLink,true);cartLink.textContent=text.cart;
    const actions=document.createElement('span');actions.setAttribute('style','display:flex;flex-wrap:wrap;gap:10px;margin-top:12px;');
    container.replaceChildren(message,actions);
    if(options.continueChoosing){
      const continueButton=document.createElement('button');continueButton.type='button';styleAction(continueButton);continueButton.textContent=text.continue;
      continueButton.addEventListener('click',options.continueChoosing);actions.append(continueButton);
    }
    actions.append(cartLink);
  }
  let busy=false;
  const request=async(url,options)=>{const r=await fetch(root+url,options);if(!r.ok)throw Error(ui.unavailable);return r.json();};
  async function add(entries){
    if(busy)throw Error(ui.adding);
    busy=true;
    try{
      const catalog=await window.MACatalog.response(document.querySelector('[data-ma-unified]').dataset.catalog).then(r=>r.json());
      const flow=new Map(catalog.filter(p=>p.eligible).map(p=>[String(p.id),p]));
      const cart=await request('cart.js',{cache:'no-store'}),items=[],next=[...cart.items];
      for(const entry of entries){
        const p=entry.product,v=p?.variants.find(v=>String(v.id)===String(entry.variantId));
        if(!v?.available||v.stock<1)throw Error(ui.unavailable);
        const live=await request('products/'+encodeURIComponent(v.sourceHandle||p.handle)+'.js',{cache:'no-store'});
        const actual=live.variants.find(x=>String(x.id)===String(v.id));
        if(!actual?.available||actual.price!==(p.eligible?1250:(v.price||p.price)))throw Error(ui.unavailable);
        next.push({product_id:p.id,variant_id:v.id,quantity:1});
        items.push({id:v.id,quantity:1});
      }
      if(!items.length)throw Error(ui.unavailable);
      const added=await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      await refresh(cart.item_count+items.reduce((total,item)=>total+item.quantity,0));
      return added;
    }catch(e){throw Error(e.message||ui.cartError);}finally{busy=false;}
  }
  window.MACart={add,confirm,refresh};
})();
